import { apiRequest, getAuthHeader } from "../utils/api";

export enum SortValues {
  CREATED_AT = "created_at",
}

export enum SortOrder {
  ASC = "asc",
  DESC = "desc",
}

export class ReadingService {
  static async getMessages(requestId: string, params = null, signal?: AbortSignal) {
    let url = `/api/reading_request_messages/${requestId}`;

    if (params) {
      const qs = new URLSearchParams(params).toString();
      url += `?${qs}`;
    }

    return apiRequest(url, {
      headers: { ...getAuthHeader() },
      signal,
    });
  }

  static async getLastMessage(requestId: string) {
    const url = `/api/reading_request_messages/${requestId}?sort=${SortValues.CREATED_AT}&order=${SortOrder.DESC}&limit=1`;

    const { data } = await apiRequest(url, {
      headers: { ...getAuthHeader() },
    });

    if (!data?.results) {
      return null;
    }

    const [last] = data.results;
    return last;
  }

  static async editStatus(
    requestId: string,
    isRushed: boolean,
    isOracle: boolean,
    isFeelings: boolean,
    numberOfTarotCards: string
  ) {
    return await apiRequest(`/api/reading_requests/${requestId}`, {
      method: "PATCH",
      body: {
        isRushed,
        isOracle,
        isFeelings,
        numberOfTarotCards,
        usePreviousDate: true,
      },
      headers: { ...getAuthHeader() },
    });
  }
}
